export const toolTypes = {
  RECTANGLE: "RECTANGLE",
  LINE: "LINE",
  PENCIL: "PENCIL",
  TEXT: "TEXT",
  SELECTION: "SELECTION",
};
